import {
  SubscriptionAddon,
  SubscriptionBundle,
  SubscriptionModule,
  WorkspaceLocale,
  WorkspaceType,
} from "@coronet/cui";

// Subscription + workspace enums and default form-state are re-exported from
// @coronet/cui (single source of truth). Kept re-exported here so existing
// `@/constants/workplaces` imports keep working unchanged. WorkspaceLocale keeps the
// console's member order in cui: getBrowserLocale (_helpers/dom.ts) takes the first
// locale of a language from Object.values(WorkspaceLocale).
export {
  SubscriptionAddon,
  SubscriptionBundle,
  SubscriptionModule,
  WorkspaceLocale,
  WorkspaceType,
};
export { defaultSubscriptionModulesConfig } from "@coronet/cui";

export enum WorkspaceAction {
  INVITE = "invite",
  SELECT_WORKPLACE = "selectWorkplace",
  JOIN = "join",
  LAUNCH = "launch",
  LAUNCH_WITH_2FA = "launchWorkplaceWith2FASetup",
  NAVIGATE_TO_GLOBAL_VIEW = "navigateToGlobalView",
}

export enum MspWorkspaceAction {
  CREATE_CHILD_WORKSPACE = "createChildMspWorkspace",
  CREATE_CHANNEL_WORKSPACE = "createChannelMspWorkspace",
  CREATE_REGULAR_WORKSPACE = "createRegularWorkspace",
  EDIT_WORKSPACE = "editWorkspace",
  DELETE_WORKSPACE = "deleteWorkspace",
  VIEW_WORKSPACE = "viewWorkspace",
  CONVERT = "convertWorkspace",
  EXPORT_WORKSPACES_LIST = "exportMsp",
  EDIT_SUBSCRIPTION = "editMspSubscription",
  START_SUBSCRIPTION = "startMspSubscription",
  STOP_SUBSCRIPTION = "stopMspSubscription",
  EDIT_SUBSCRIPTION_CONFIRMATION = "editMspSubscriptionConfirmation",
  EXPORT_MSP_NOTIFICATIONS = "exportMspNotifications",
  EXPORT_MSP_SUMMARY = "exportMspSummary",
  ARCHIVE_WORKSPACE = "archiveMspWorkspace",
  UNARCHIVE_WORKSPACE = "unarchiveMspWorkspace",
  EXTEND_TRIAL = "extendMspTrial",
  START_TRIAL = "startTrial",
  VIEW_PROTECTED_USERS = "viewProtectedUsers",
  VIEW_DEVICES = "viewDevices",
  VIEW_TICKETS = "viewTickets",
  BULK_SUBSCRIPTION_CONFIRMATION = "mspBulkSubscriptionChangeConfirmation",
  START_BULK_SUBSCRIPTION = "startBulkMspSubscription",
  STOP_BULK_SUBSCRIPTION = "stopBulkMspSubscription",
  EDIT_MSP_WORKSPACE_LABEL = "editMspWorkspaceLabel",
  ADD_MSP_BULK_LABEL = "addBulkMspLabel",
  ASSIGN_GLOBAL_POLICY = "assignGlobalPolicy",
  ASSIGN_GLOBAL_POLICY_CONFIRMATION = "mspAssignGlobalPolicyConfirmation",
}

export type TicketGeneratingSubscriptionModule =
  | SubscriptionModule.CLOUD_SECURITY
  | SubscriptionModule.ENDPOINT_SECURITY
  | SubscriptionModule.EMAIL_SECURITY
  | SubscriptionModule.USER_DATA_GOVERNANCE
  | SubscriptionModule.ENDPOINT_DATA_GOVERNANCE
  | SubscriptionModule.EDR;

export enum SubscriptionType {
  INITIAL = "initial",
  FREEZE = "freeze",
  TRIAL = "trial",
  SUBSCRIPTION = "subscription",
  ARCHIVED = "archived",
}

export enum SubscriptionsFilterType {
  ADDON = "addon",
  BUNDLE = "bundle",
  MODULE = "module",
}

export enum WorkspaceNavigationButton {
  GLOBAL = "globalView",
  WORKSPACE = "workspaceView",
}
